module.exports = "/src/views/player/help/images/gov2.jpg";